<template>
  <labeled-form-control label="Date of Birth">
    <datepicker v-model="date"
      :disabled-dates="disabledDates"
      :clearable="true"
      :placeholder="'Select a Date'"
      wrapper-class="registration-calendar"
      input-class="registration-calendar-input"
      :clear-button="true"
      :full-month-name="true"
      :initial-view="'year'">
    </datepicker>
  </labeled-form-control>
</template>

<script>
import moment from 'moment-timezone'
import { mapGetters, mapMutations } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import LabeledFormControl from '@/components/Layout/LabeledFormControl.vue'

export default {
  name: 'PetDob',
  props: {
    petId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('ClientRegistrationUpload', [
      'findPet'
    ]),
    disabledDates () {
      const tomorrow = new Date(moment().format().split('T')[0])
      tomorrow.setDate(tomorrow.getDate() + 1)
      return {
        from: tomorrow
      }
    },
    pet () {
      return this.findPet(this.petId)
    },
    date: {
      get () {
        return this.pet.dateOfBirth
      },
      set (value) {
        this.updateDateOfBirth({ petId: this.petId, value })
      }
    },
    calendarIcon () {
      return 'fas fa-calendar'
    }
  },
  methods: {
    ...mapMutations('ClientRegistrationUpload', [
      'updateDateOfBirth'
    ])
  },
  components: {
    'labeled-form-control': LabeledFormControl,
    Datepicker
  }
}
</script>

<style>
.registration-calendar:hover,
.registration-calendar-input:hover {
  cursor: pointer !important;
}
.registration-calendar {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.registration-calendar .vdp-datepicker__calendar {
  margin-top: 0.25rem;
  margin-left: -0.75rem;
}
.registration-calendar-input {
  width: 100% !important;
  color: #495057;
  font-size: 1rem;
  border: none;
}
.registration-calendar-input:focus{
  outline: none;
}
.registration-calendar div:first-child {
  display: flex;
  justify-content: space-between;
  align-items: centers;
}
</style>
